module.exports = {"TXTCLI_Select_All":{"id":"TXTCLI_Select_All","defaultMessage":"Marker alt","track":"Select All"}}